// Set the date we're counting down to

const countdownEl = document.getElementById("announcement-countdown");

if (countdownEl) {
  const countDownConfig = countdownEl.dataset;
  var countDownDate = new Date(countDownConfig.targetTime).getTime();

  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
    countdownEl.innerHTML = `⏰ <div><b>${
      days.toString().length > 1 ? days : `0${days}`
    }</b><span>d</span></div><div><b>${
      hours.toString().length > 1 ? hours : `0${hours}`
    }</b><span>u</span></div><div><b>${
      minutes.toString().length > 1 ? minutes : `0${minutes}`
    }</b><span>m</span></div><div><b>${
      seconds.toString().length > 1 ? seconds : `0${seconds}`
    }</b><span>s</span></div></span>`;

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      countdownEl.innerHTML = "<div><b>Expired</b></div>";
    }
  }, 1000);
}
